import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const TagFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M18.87 3h-.19l-5.09.45c-.6.05-1.16.31-1.59.74L2.79 13.4c-.3.3-.26.83.09 1.18l6.54 6.54c.19.19.44.29.67.29.19 0 .37-.07.51-.2L19.81 12c.43-.43.69-.99.74-1.59L21 5.32c.11-1.26-.89-2.33-2.13-2.33V3Zm-3.04 6.99c-.91 0-1.65-.74-1.65-1.65 0-.91.74-1.65 1.65-1.65.91 0 1.65.74 1.65 1.65 0 .91-.74 1.65-1.65 1.65Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default TagFilled
